(function($) {

	$.fn.googleMap = function(options) {

		var elem = $(this),
			mapDomelem = elem.find('.js-google-map__canvas'),
			mapElem = null,
			mapMarker = null,
			hiddenParentElem = $(),
			settings = {
				geoApi: {
					url: 'https://maps.google.com/maps/api/geocode/json?key=AIzaSyB5emWQe4M-J646ZYFv7Er5GcXYMSefxNg&address={{address}}&sensor=false',
					address_processer: '/ajax/General.aspx/ProcessAddressForGeo'
				},
				mapOptions: {
					zoomControl: true,
					streetViewControl: true,
					panControl: true,
					overviewMapControl: true,
					scaleControl: true,
					scrollwheel: false,
					navigationControl: true,
					mapTypeControl: true,
					scaleControl: true,
					draggable: true,
					zoom: 16,
					disableDoubleClickZoom: true,
					center: null,
					mapTypeId: null
				},
				map_marker_image: {
					url: '/images/misc/map-marker.png',
					orig_width: 108,
					orig_height: 128
				},
				lat: false,
				lng: false,
				address: '',
				hidden_parent: false,
				refreshTimeout: 500
			};

			var init = function() {

				// Parse settings
        if (options){
          settings = $.extend(true, {}, settings, options);
        }else{
          settings = $.extend(true, {}, settings, elem.parseSettings());
        }

				loadApi();

				// If the map is in a hidden parent (e.g. tabs), then listen out for 'parent_active' event
				if(settings.hidden_parent) {

					// Find parent, defined in settings
					hiddenParentElem = $(settings.hidden_parent);

					if(hiddenParentElem.any()) {

						// Slice off the top one so we don't get bubbling
						hiddenParentElem = hiddenParentElem.eq(0);

						// Listen out and refresh
						hiddenParentElem.on('parent_active', function() {
							refreshMap();
						});
					}
				}
			},

			// Load api scrips and run callback
			loadApi = function() {

				if (typeof(google) == 'undefined' || typeof(google.maps) === 'undefined') {

					var scriptElem = document.createElement('script');

					scriptElem.type = 'text/javascript';
					scriptElem.src  = '//maps.google.com/maps/api/js?key=AIzaSyB5emWQe4M-J646ZYFv7Er5GcXYMSefxNg&v=3&callback=gmapLoaded';

					// Set an onload callback
					window.gmapLoaded = function() {
						 render();
					};

					$('head').append(scriptElem);

				}
				else {
					render();
				}

			},

			// Render the map
			render = function(lat, lng) {

				function callback(lat, lng) {
					// Reset some map options
					settings.mapOptions.center = new google.maps.LatLng(lat, lng);
					settings.mapOptions.mapTypeId = google.maps.MapTypeId.ROADMAP;

					// Set the map element
					if(mapElem == null) {

						mapElem = new google.maps.Map(mapDomelem[0], settings.mapOptions);
					}
					else {

						mapElem.setCenter({lat:lat, lng:lng});
					}

					// Set the marker
					if(mapMarker == null) {

						mapMarker = new google.maps.Marker({
							position: new google.maps.LatLng(lat, lng),
							map: mapElem,
							icon: {
								url: settings.map_marker_image.url,
								size: new google.maps.Size(settings.map_marker_image.orig_width, settings.map_marker_image.orig_width),
								origin: new google.maps.Point(0, 0),
								anchor: new google.maps.Point(((settings.map_marker_image.orig_width / 2) / 2), (settings.map_marker_image.orig_height / 2)),
								scaledSize: new google.maps.Size((settings.map_marker_image.orig_width / 2), (settings.map_marker_image.orig_height / 2))
							}
						});
					}
					else {
						mapMarker.setPosition({lat:lat, lng:lng});
					}
				}

				// If nothing passed in, then get data from settings
				if(typeof(lat) == 'undefined' && typeof(lng) == 'undefined') {

					// Set default coordinates if something went wrong in previous methods
					if(!settings.lat && !settings.lng) {
						lat = settings.defaultLat;
						lng = settings.defaultLng;
					}

					// Set calculated or passed lat and lng
					else {
						lat = settings.lat;
						lng = settings.lng;
					}
				}

				// Cache lat and lng, just in case
				else {
					if(!settings.lat && !settings.lng) {
						settings.lat = lat;
						settings.lng = lng;
					}
				}

				if (lat && lng) {
					callback(lat, lng);
				}
				else {
					var geocoder = new google.maps.Geocoder();
					geocoder.geocode( { 'address': settings.address}, function(results, status) {
						if (status === 'OK') {
							var loc = results[0].geometry.location;
							settings.lat = loc.lat();
							settings.lng = loc.lng();

							callback(settings.lat, settings.lng);
						}
					});
				}
			},

			refreshMap = function() {

				setTimeout(function() {

					// This should never happen but it's here for just in case
					if(!settings.lat && !settings.lng) {
						render();
					}
					else {

						// Center the map and trigger a resize event
						google.maps.event.trigger(mapElem, 'resize');
						mapElem.setCenter({lat:settings.lat, lng:settings.lng});
					}

				}, settings.refreshTimeout);

			};

			init();
			return this;
	};

}($));
